import React, { useEffect, useState } from "react";
import { TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { WebView } from "../../webView/WebView";
import TooltipComp from "../TooltipComp";
import { Button } from "../../button/Button";
import { isMobileView } from "../../stack/utils";
import { showShareLink } from "../utils";
const PLJJourneyPage = ({ height, triggerAction, url, eventAction, onLoadCompleteAction, userFullName, closeAction, shareLinkAction, copyLinkAction, copyLinkText }) => {
    const isFromMobile = isMobileView();
    const [userFullPANName, setUserFullPANName] = useState('');
    const [userName, setUserName] = useState('');
    const [showLink, setShowLink] = useState(showShareLink());
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.includes('userFullPANName')) {
                const fullPANName = event.data.replace('userFullPANName', '').trim();
                setUserFullPANName(fullPANName);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    useEffect(() => {
        if (userFullPANName) {
            setUserName(userFullPANName);
        }
        else {
            setUserName(userFullName);
        }
    }, [userFullPANName, userFullName]);
    const [showToolTip, setShowToolTip] = useState(false);
    const shareLinkToolTip = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                top: 200,
                left: 220,
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(TooltipComp, { width: 268, tooltipArrowBottomPosition: 280, children: React.createElement(View, { style: { paddingHorizontal: -4, paddingBottom: 4 } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: "Share loan application link" }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                setShowToolTip(false);
                            }, style: { width: 14, height: 14 }, hitSlop: { top: 12, bottom: 12, left: 12, right: 12 } },
                            React.createElement(Icon, { name: IconTokens.CrossIcon, size: IconSizeTokens.XS }))),
                    React.createElement(View, { style: { marginTop: 2 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: "Client can finish their loan application using this unique link." })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 12,
                            height: 24,
                            justifyContent: 'center',
                        } },
                        React.createElement(View, { style: { width: 117, height: 24 } },
                            React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, typeDLS: ButtonTypeDLS.SECONDARY, sizeDLS: ButtonSizeDLS.SMALL, label: "Whatsapp ", iconName: IconTokens.WHATSAPP_OUTLINE, iconAlignment: "right", customWidth: 90, height: 20, icon: { name: IconTokens.Whatsapp, size: IconSizeTokens.XS }, fontSize: FontSizeTokens.XS, onPress: () => {
                                    triggerAction({
                                        ...shareLinkAction
                                    });
                                } })),
                        React.createElement(View, { style: { marginLeft: 12, width: 111, height: 24 } },
                            React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: `${copyLinkText} `, typeDLS: ButtonTypeDLS.SECONDARY, iconName: IconTokens.Copy, iconAlignment: "right", customWidth: 80, height: 20, sizeDLS: ButtonSizeDLS.SMALL, icon: { name: IconTokens.Copy, size: IconSizeTokens.XS }, fontSize: FontSizeTokens.XS, onPress: () => {
                                    triggerAction({
                                        ...copyLinkAction
                                    });
                                } })))), tooltipArrowLeftPosition: 240, leftShiftContent: -130 })));
    };
    const body = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { height: height, flex: 1 }, onPress: () => {
                setShowToolTip(false);
            } },
            React.createElement(View, { style: {
                    height: 50,
                    width: '100%',
                    backgroundColor: '#667085',
                    flexDirection: 'row',
                    alignContent: 'center',
                    alignItems: 'center',
                    paddingLeft: 8,
                    paddingRight: 16,
                    justifyContent: 'space-between'
                } },
                React.createElement(View, { style: { flexDirection: 'row', paddingVertical: 5, alignContent: 'flex-end', alignItems: 'flex-end', justifyContent: 'flex-end' } },
                    React.createElement(View, { style: { marginBottom: 1 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: "Viewing as ", color: ColorTokens.White })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, label: isFromMobile ? userName?.length < 12 ? userName?.toUpperCase() : `${userName?.slice(0, 12).toUpperCase()}...` : userName?.length < 20 ? userName?.toUpperCase() : `${userName?.slice(0, 20).toUpperCase()}...`, color: ColorTokens.White }),
                    showLink &&
                        React.createElement(TouchableOpacity, { style: {
                                borderRadius: 32,
                                width: 88,
                                borderWidth: 1,
                                borderColor: 'white',
                                flexDirection: 'row',
                                alignContent: 'center',
                                alignItems: 'center',
                                marginLeft: 24,
                                justifyContent: 'center',
                                paddingVertical: 4
                            }, onPress: () => {
                                setShowToolTip(!showToolTip);
                            } },
                            React.createElement(Icon, { name: IconTokens.Share, size: IconSizeTokens.LG, color: ColorTokens.White }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: " Share", color: ColorTokens.White }))),
                React.createElement(TouchableOpacity, { style: { justifyContent: 'flex-end', width: 32, height: 32 }, onPress: () => {
                        triggerAction({
                            ...closeAction
                        });
                    }, hitSlop: { top: 12, bottom: 12, left: 12, right: 12 } },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XXXXL, color: ColorTokens.White }))),
            React.createElement(WebView, { uri: url, iframe: true, width: isFromMobile ? '100%' : '500', shouldScroll: true, eventAction: eventAction, height: height - 50, onLoadCompleteAction: onLoadCompleteAction, triggerAction: triggerAction, eventId: "openRegisterLead" })));
    };
    return (React.createElement(View, null,
        body(),
        showToolTip && shareLinkToolTip()));
};
// @ts-ignore
export default (PLJJourneyPage);
